import { Link } from "react-router-dom";
import { BRAND } from "../../brand";
import { Megaphone, Bot, Filter, Trophy, ArrowRight } from "lucide-react";

const stages = [
  { icon: Megaphone, t: "Tráfico", d: "Google · Meta · TikTok Ads" },
  { icon: Bot, t: "Automatización", d: "IA + chatbots omnicanal" },
  { icon: Filter, t: "Calificación", d: "Reglas + scoring + CRM" },
  { icon: Trophy, t: "Ventas", d: "Cierre humano + retargeting" },
];

export default function FunnelsAds() {
  return (
    <section id="funnels" data-testid="funnels-section" className="relative py-24 sm:py-32">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 reveal">
            <div className="eyebrow mb-5">Funnels & Publicidad Digital</div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
              Un sistema completo, no campañas <span className="text-gradient">sueltas</span>.
            </h2>
            <p className="mt-6 text-zinc-400 text-lg max-w-md">
              Tráfico pagado conectado a automatización, IA y un proceso comercial. Cada lead entra a una máquina diseñada para convertir.
            </p>
            <Link to="/contacto" className="btn-primary mt-8" data-testid="funnels-cta">
              Diseña mi sistema <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="relative grad-border p-8 sm:p-10 overflow-hidden">
              <img src={BRAND.images.funnel} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/40 to-[#050505]/80" />
              <div className="relative grid grid-cols-1 sm:grid-cols-4 gap-4">
                {stages.map(({ icon: Icon, t, d }, i) => (
                  <div key={t} className="relative">
                    <div className="glass-strong rounded-2xl p-5 h-full">
                      <div className="w-10 h-10 rounded-lg bg-gradient-brand grid place-items-center text-black mb-3">
                        <Icon className="w-5 h-5" strokeWidth={2.5} />
                      </div>
                      <div className="text-[10px] tracking-[0.2em] uppercase text-[#ff8a00] font-display">Paso 0{i + 1}</div>
                      <div className="text-white font-display font-bold text-lg mt-1">{t}</div>
                      <div className="text-zinc-400 text-[13px] mt-1.5 leading-relaxed">{d}</div>
                    </div>
                    {i < stages.length - 1 && (
                      <div className="hidden sm:block absolute top-1/2 -right-3 -translate-y-1/2 z-10">
                        <ArrowRight className="w-4 h-4 text-[#ff8a00]" />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
